import { render, staticRenderFns } from "./help-list.html.vue?vue&type=template&id=920125f0"
import script from "./help-list.html.vue?vue&type=script&lang=js"
export * from "./help-list.html.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/help/helpList.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/help/helpList.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./help-list.html.vue?vue&type=style&index=2&id=920125f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HelpBanner: require('/src/components/help/helpBanner.vue').default})
